// src/api/menus.js
import api from "./index";

// Constantes pour les channels
export const SUPPLYVET_CHANNEL = "supplyvet";
export const ESUPPLYVET_CHANNEL = "esupplyvet";

/*******************************Module Menus********************************/

/**
 * Récupère les menus depuis l'API v2
 * @param {string} channel - Code du channel à filtrer (par défaut: supplyvet)
 * @param {Object} apiInstance - Instance API à utiliser (par défaut: api)
 * @returns {Promise} Réponse de l'API contenant les menus
 */
export function getMenus(channel = SUPPLYVET_CHANNEL, apiInstance = api) {
  return apiInstance.get("/menus", {
    params: {
      channel: channel,
    },
  });
}

/**
 * Récupère un menu spécifique par son ID
 * @param {number} menuId - ID du menu à récupérer
 * @param {Object} apiInstance - Instance API à utiliser (par défaut: api)
 * @returns {Promise} Réponse de l'API contenant le menu
 */
export function getMenu(menuId, apiInstance = api) {
  return apiInstance.get(`/menus/${menuId}`);
}
